import { exhaustiveSwitchWithDefault } from "@faire/web--source/common/exhaustiveSwitchWithDefault";

import { DataByLocale } from "@faire/retailer/lib/localization";
import { getSafeEnvName } from "@faire/retailer-visitor-shared/serialized-data/getEnvName";

import { TOSType, TOSCountryType, TOS_ZENDESK_ARTICLE_IDS } from "./consts";
import { getBrandTOSArticleData } from "./getBrandTOSArticleData";
import { getFairePayTOSArticleData } from "./getFairePayTOSArticleData";
import { getInsiderTOSArticleData } from "./getInsiderTOSArticleData";
import { getMainTOSArticleData } from "./getMainTOSArticleData";
import { getOwfGrantTOSArticleData } from "./getOwfGrantTOSArticleData";
import { getRetailerTOSArticleData } from "./getRetailerTOSArticleData";

export const chooseArticleId = (
  tosType: TOSType,
  tosCountryType: TOSCountryType
): string => {
  return TOS_ZENDESK_ARTICLE_IDS[tosType][getSafeEnvName()][tosCountryType];
};

export const getZendeskArticleData = async (
  tosType: TOSType
): Promise<DataByLocale> => {
  switch (tosType) {
    case TOSType.MAIN:
      return getMainTOSArticleData();
    case TOSType.RETAILER:
      return getRetailerTOSArticleData();
    case TOSType.BRAND:
      return getBrandTOSArticleData();
    case TOSType.INSIDER:
      return getInsiderTOSArticleData();
    case TOSType.FAIRE_PAY:
      return getFairePayTOSArticleData();
    case TOSType.OWF_GRANT:
      return getOwfGrantTOSArticleData();
    default:
      return exhaustiveSwitchWithDefault(getMainTOSArticleData())(tosType);
  }
};
